import { Button, Grid, Paper } from "@material-ui/core";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BasicModal from "../../components/BasicModal";
import DateRange from "../../components/DateRange";
import DropdownFilter from "../../components/DropdownFilter";
import LotsDropdown from "../../components/SharedDropdowns/LotsDropDown/LotsDropDown";
import { useGetClientsWithConfigsQuery } from "../clients/clientConfigSlice";
import { useGetClientsQuery } from "../clients/clientSlice";
import { useGetLotsQuery } from "../lots/lotSlice";
import { selectIsAccountManager, selectIsAdmin, selectIsClient, selectIsOwner, selectIsSaasManager } from "../user/userSlice";
import { dashboardStyles } from "./DashboardStyle";
import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import BillingDashboard from "./components/BillingDashboard";
import DispatchDashboard from "./components/DispatchDashboard";
import NumberOfMovementReport from "./components/DispatchDashboard/NumberOfMovementReport";
import FleetManagementDashboard from "./components/FleetManagementDashboard";
import KpiDashboardPage from "./components/KpiDashboard/KpiDashboardPage";
import WashDashboardPage from "./components/WashDashboard/WashDashboardPage";
import { hasPermission } from "components/Authorize/authorizeUtil";
import { permissions } from "components/Authorize/permissions/permissions";
import LoadsDashboard from "features/loads/components/LoadsDashboard";
import { useGetCurrentTenantConfigQuery } from "features/me/meSlice";
import { tenantFeatureFlagNames } from "features/saasManagement/TenantConfig/tenantConfigConsts";
import NewWashDashboardPage from "./components/NewWashDashboard/NewWashDashboardPage";
import WorkorderDashboardPage from "./components/WorkorderDashboard/WorkorderDashboardPage";
import { setFilters } from "./dashboardSlice";

const DashboardPage = () => {
    const isSaasManager = useSelector(selectIsSaasManager);
    const dashboardNameIdMap = {
        // access: 1,
        wash: 1,
        newWash: 2,
        kpi: 3,
        dispatch: 4,
        mechanical: 5,
        billing: 6,
        fleetManagement: 7,
        loads: 8
    }

    const classes = dashboardStyles();
    let { data: lots, isLoading: isLoadingLots } = useGetLotsQuery();
    let { data: clients, isLoading: isLoadingClients } = useGetClientsQuery();
    let { data: clientsWithConfigs, error: clientsWithConfigsError, isFetching: isLoadingClientsWithConfigs } = useGetClientsWithConfigsQuery(null);
    let { data: currentTenantConfig, error, isLoadingTenantConfig } = useGetCurrentTenantConfigQuery();

    const clientAccounts = clients?.flatMap(c => c.clientAccounts);

    const clientsWithConfigsLookup = clientsWithConfigs?.reduce(function (map, obj) {
        map[obj.id] = obj;
        return map;
    }, {});

    const clientLots = lots?.flatMap(c => c.clientLots)?.filter(cl => cl.useWashProgram && clientsWithConfigsLookup?.[cl.clientId]?.config?.washConfig?.useWashProgram);

    const clientAccountLookup = clientAccounts?.reduce(function (map, obj) {
        map[obj.id] = obj;
        return map;
    }, {});

    clientsWithConfigs = clientsWithConfigs || [];
    lots = lots || [];


    const params = useParams();
    const history = useHistory();
    const dashboardNameId = dashboardNameIdMap[params?.type];

    const isClient = useSelector(selectIsClient);
    const isOwner = useSelector(selectIsOwner);
    const isAdmin = useSelector(selectIsAdmin);
    const isAcctManager = useSelector(selectIsAccountManager);
    const [openSelectFieldsPopup, setOpenSelectFieldsPopup] = useState(false);
    let isUsingTransports = false;

    if (isClient) {
        isUsingTransports = clientsWithConfigs?.length ? clientsWithConfigs?.some(c => c?.config?.transportConfig?.useTransport) : false;
    } else {
        isUsingTransports = true;
    }

    const [clientAccountId, setClientAccountId] = useState();
    const [lotIds, setLotIds] = useState([]);
    let lotsWithWashProgram = lots?.filter(l => clientLots?.find(cl => cl?.lotId === l.id));

    if (clientAccountId) {
        lotsWithWashProgram = lotsWithWashProgram?.filter(l => l.clientLots?.some(cl => cl?.clientId === clientAccountLookup?.[clientAccountId]?.clientId && cl?.useWashProgram))
    }

    const clientHasWashContract = isClient ? clientsWithConfigs?.some(c => c?.config?.washConfig?.useWashProgram) : true;

    const [dashboard, setDashboard] = React.useState(7);

    const dispatch = useDispatch();
    const { filters } = useSelector(state => state.dashboardState);


    const [showClientFilter, setShowClientFilter] = useState(false);
    const [showLotFilter, setShowLotFilter] = useState(false);
    const [showDateFilter, setShowDateFilter] = useState(false);
    const [showMovememntsButton, setShowMovememntsButton] = useState(false);

    const resetFilters = () => {
        setShowClientFilter(false);
        setShowLotFilter(false);
        setShowDateFilter(false);
        setShowMovememntsButton(false);
    }

    useEffect(() => {
        if (isSaasManager) {
            history.push('/saas');
        }
    }, [isSaasManager]);

    useEffect(() => {
        if (dashboards.find(d => d.id == dashboardNameId)) {
            setDashboard(dashboardNameId);
            setLotIds([]);
            dispatch(setFilters({ clientId: '', clientAccountId: '', isDefaultAccount: false, lotId: Array(0) }));

            resetFilters();

            if (dashboardNameId == 1) {
                setShowClientFilter(true);
                setShowLotFilter(true);
            }

            else
                if (dashboardNameId == 3) {
                    setShowLotFilter(false);
                }

                else if (dashboardNameId == 4) {
                    setShowClientFilter(true);
                    setShowMovememntsButton(true);
                }

            // else {//Mechanicals is the default
            //     !isClient && setShowClientFilter(true);
            //     setShowLotFilter(true);
            //     setShowDateFilter(true);
            // }
        }
    }, [params])

    const handleChange = (val) => {
        const dashboardKey = dashboards?.find(d => d.id == val);
        history.push(`/dashboard/${dashboardKey?.key}`);
    };

    const handleFilterChange = (key, value) => {
        if (key == 'clientAccountId') {
            setClientAccountId(value);
            setLotIds([]);
            dispatch(setFilters({
                ...filters, [key]: value, ['lotId']: [], ['clientId']: clientAccountLookup?.[value]?.clientId,
                ['isDefaultAccount']: clientAccountLookup?.[value]?.isDefault
            }));
            return;
        }
        if (key == 'lotId') {
            setLotIds(value);
        }
        dispatch(setFilters({ ...filters, [key]: value }));
    }

    const onSelectExistingClick = () => {
        setOpenSelectFieldsPopup(true)
    }

    const dashboards = [
        // { id: 1, name: 'Access Dashboard', key: 'access' },
    ];

    if (clientHasWashContract) {
        dashboards.push({ id: 1, name: 'Wash Dashboard', key: 'wash' });
        dashboards.push({ id: 2, name: 'New Wash Dashboard', key: 'newWash' });
    }

    if (isOwner || (hasPermission(permissions.DASHBOARD.DISPATCH_DASHBOARD_VIEW.key))) {
        dashboards.push({ id: 4, name: 'Dispatch Dashboard', key: 'dispatch' });
    }
    if (currentTenantConfig?.tenantFeatureFlags?.[tenantFeatureFlagNames.UseLotKpis] && (isOwner || isAcctManager || (isAdmin && hasPermission(permissions.DASHBOARD.KPI_DASHBOARD_VIEW.key)))) {
        dashboards.push({ id: 3, name: 'KPI Dashboard', key: 'kpi' });
    }

    dashboards.push({ id: 5, name: 'Mechanical Dashboard', key: 'mechanical' })
    dashboards.push({ id: 7, name: 'Fleet Management', key: 'fleetManagement' })

    // if (isOwner) {
    //     dashboards.push({ id: 6, name: 'Billing Dashboard', key: 'billing' });

    // }
    if (isUsingTransports) {
        dashboards.push({ id: 8, name: 'Loads Dashboard', key: 'loads' });
    }


    const dashboardMap = {
        1: <WashDashboardPage />,
        2: <NewWashDashboardPage />,
        3: <KpiDashboardPage />,
        4: <DispatchDashboard />,
        //5: <MechanicalDashboard />,
        5: <WorkorderDashboardPage />,
        6: <BillingDashboard />,
        7: <FleetManagementDashboard />,
        8: <LoadsDashboard />
    }



    return (
        <>
            {/* {!isLoading() ? */}
            <Paper className={`${classes.card} ${classes.dashboard}`} elevation={1}>

                <Grid container spacing={1} className={classes.filters} alignItems="center">
                    {/* {dashboards?.length > 1 &&
                            <Grid item xs={4}>
                                <DropdownFilter
                                    values={dashboards}
                                    onSelect={handleChange}
                                    value={dashboard}
                                />
                            </Grid>} */}

                    {showClientFilter && <>
                        {clients?.length > 1 &&
                            <Grid item xs>
                                <DropdownFilter
                                    values={[{ id: '', name: 'All clients' }, ...(clientAccounts ?? [])]}
                                    onSelect={(val) => handleFilterChange('clientAccountId', val)}
                                    value={filters?.['clientAccountId']}
                                />
                            </Grid>
                        }</>
                    }

                    {showLotFilter &&
                        <Grid item xs>
                            <LotsDropdown
                                pmfLot
                                clientId={clientAccountLookup?.[clientAccountId]?.clientId}
                                title='Lot'
                                identifier='lot'
                                filteredLots={clientAccountId && dashboardNameId === 2 ? lotsWithWashProgram : null}
                                onSelect={(val) => handleFilterChange('lotId', val)}
                                value={lotIds}
                                showEmpty={true}
                                multiple={true}
                            />
                        </Grid>
                    }

                    {showDateFilter && <>
                        <Grid item xs>
                            <DateRange
                                title='Time Frame'
                                onSelect={(val) => handleFilterChange('date', val)}
                                dateValue={null}
                            />
                        </Grid>
                    </>}

                    {showMovememntsButton && <>
                        <Grid item xs={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                onClick={onSelectExistingClick}>
                                Number of Movememnts per day per lot Report
                            </Button>
                        </Grid>
                        <BasicModal
                            open={openSelectFieldsPopup}
                            header={`Select Date Range`}
                            handleClose={() => setOpenSelectFieldsPopup(false)}
                            component={<NumberOfMovementReport
                                handleClose={() => setOpenSelectFieldsPopup(false)} />}
                        />
                    </>}

                </Grid>
                {
                    dashboardMap[dashboard]
                }

            </Paper>
            {/* //     : <CircularProgress className={classes.spinner} />
            // } */}
        </>
    );
};

export default DashboardPage;
